import { AnalyticsTrackingActionTypes } from '@store/analytics'

export const trackEvent = (name: string, properties: any) => ({
  type: AnalyticsTrackingActionTypes.SEND_TRACKING_REQUEST,
  payload: {
    name,
    properties,
  },
})

export const trackEventSuccess = (name: string, properties: any) => ({
  type: AnalyticsTrackingActionTypes.SEND_TRACKING_SUCCESS,
  payload: {
    name,
    properties,
  },
})
